<template>
  <div class="small-12 column">
    <template v-if="!showUpload">
      <p class="text-small">{{'txtUploadNotRequired'|translate}}</p>
    </template>

    <template v-if="showUpload">
      <p class="text-small">{{'txtUploadFiles'|translate(globalConfig.shop.currency)}}</p>

      <div class="file-list">
        <div v-for="(file, index) in internalFiles" :key="index" class="small-12 column">
          <PrintFile :filename="file.name" :fileid="file.identifier ? file.identifier : file.id" :filestatus="file.status"
                     :file="file.file" :url="file.url" v-on:delete-file="deleteFile(index)"/>
        </div>
      </div>

      <div v-if="notSafari" @drop.prevent="dragndropFile" @dragover.prevent class="upload__input d-flex flex-column bg-shade-light pt-3 pb-3 px-2 p-4@medium flex-center text-center">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50.73 33.62" class="svg-icon upload-icon m-auto svg-icon--xxlarge"><path d="M40.71 14.63c-.37 0-.74.02-1.11.06l-1.24.13.09-1.24c.02-.3.03-.59.03-.87 0-7-5.69-12.7-12.7-12.7-3.21 0-6.28 1.2-8.63 3.38a12.68 12.68 0 00-4.03 8.28l-.09 1.1-1.09-.15c-.46-.06-.93-.09-1.4-.09C4.73 12.53 0 17.26 0 23.07c0 5.78 4.71 10.51 10.49 10.54H23.55V24.5v-.31c-.09.07-.14.11-.18.15-.68.67-1.36 1.34-2.02 2.03-.51.53-1.08.88-1.83.76-.71-.11-1.23-.51-1.48-1.18-.25-.65-.19-1.3.29-1.83.68-.75 1.42-1.46 2.14-2.19 1.18-1.19 2.37-2.37 3.55-3.56.8-.81 1.98-.81 2.67-.13.79.76 1.56 1.53 2.33 2.31l3.06 3.06c.31.3.62.6.77 1.02a1.9 1.9 0 01-.75 2.23c-.72.46-1.7.38-2.32-.23-.67-.65-1.32-1.32-1.98-1.98-.14-.15-.3-.28-.49-.47v9.42h13.45c5.5-.03 9.97-4.29 9.97-9.49 0-5.22-4.49-9.48-10.02-9.48z" fill="#cad505"></path></svg>
        <label class="label-aligned text-small mt-2">
          {{'txtUploadArea'|translate}}
        </label>
      </div>

      <SkyUploadWrapper ref="fileupload" :fileuploadid="fileuploadid" :upload-file-extensions="globalConfig.uploadFileExtensions"
                        :multiple="true"
                        @fileschanged="startUpload"
                        @uploadStarts="uploadStarts"
                        @updateUploadState="updateUploadState"
                        @uploadFinished="uploadFinished"
                        @uploadError="uploadError"
                        :text="'txtUploadPrintFile' | translate"
      />
    </template>
    <div v-if="option.currentInfo.msgType === 'INFO'"
         class="text-small mt-prj text-info d-flex line-height-12 flex-center">
      <svg xmlns="http://www.w3.org/2000/svg" class="mr-2 svg-icon flex-child-fix position-relative t-1px" x="0" y="0"
           viewBox="0 0 36 36" xml:space="preserve"><path d="M36 18.01c0 9.94-8.04 17.98-17.99 17.99C8.03 36.01-.01 27.95 0 17.93 0 8.04 8.09-.01 18.02 0 27.96.01 36 8.06 36 18.01z" fill="#62b982"/>
        <path id="XMLID_1_"
              d="M14.93 26.67l-6.46-6.46a2.07 2.07 0 010-2.93 2.07 2.07 0 012.93 0l3.55 3.55 9.66-9.56c.81-.8 2.12-.8 2.93.02.8.81.8 2.12-.02 2.93L14.93 26.67z"
              fill="#fff"/></svg>
      {{ option.currentInfo.text }}
    </div>
    <div v-if="option.currentInfo.msgType === 'ERROR'"
         class="text-small mt-prj text-error d-flex line-height-12 flex-center">
      <svg xmlns="http://www.w3.org/2000/svg" class="mr-2 svg-icon flex-child-fix position-relative t-1px"
           viewBox="0 0 36 36">
        <circle cx="18" cy="18" r="18" fill="#e94d47"/>
        <path
            d="M16.08 26.43c0-.3.05-.58.17-.85.11-.27.26-.5.46-.69.2-.19.43-.35.7-.46.27-.12.56-.17.86-.17.3 0 .58.06.85.17.27.12.5.27.69.46.19.19.34.42.46.69.12.27.17.55.17.85 0 .31-.06.59-.17.86-.12.26-.27.49-.46.68-.19.19-.42.34-.69.45a2.223 2.223 0 01-1.71 0c-.27-.11-.5-.26-.7-.45-.2-.19-.35-.42-.46-.68-.11-.27-.17-.55-.17-.86zm3.9-18.86v8.24c0 .87-.04 1.73-.13 2.57-.09.84-.2 1.73-.34 2.67h-2.4c-.14-.94-.26-1.83-.35-2.67-.09-.84-.13-1.7-.13-2.57V7.57h3.35z"
            fill="#fff"/>
      </svg>
      {{ option.currentInfo.text }}
    </div>
  </div>
</template>

<script>
import {doGet, ProduktRESTHelper} from "../classes/api.js";
import {translatePrj} from "classes/vue-dict-filter";
import PrintFile, {FILESTATUS, MAX_FILESIZE} from "./PrintFile.vue";
import SkyUploadWrapper from "../fragments/SkyUploadWrapper.vue";
import {isSafari, uEqual} from "../classes/helpers";
import {OVERALLSTATUS} from "../models/enums";

export default {
  components: {SkyUploadWrapper, PrintFile},
  props: ['option','fileuploadid'],
  inject: ['globalConfig', 'configuratorService', 'shopItemId'],
  data() {
    return {
      internalFiles: []
    }
  },
  methods: {
    loadFilesForBasketItem: function () {
      if( this.shopItemId ) {
        doGet("/api/prj/uploadfiles/" + this.shopItemId + ".de.json").then(resp => {
          this.internalFiles.splice(0, this.files.length);
          resp.uploadFiles.forEach(file => {
            this.internalFiles.push(
                {
                  name: file.name,
                  id: file.id,
                  status: FILESTATUS.OK,
                  url: file.url,
                  generated: file.generated
                }
            )
          })
        })
      }
    },
    deleteFile: function( index ) {
      this.internalFiles.splice(index, 1);
      this.validateConfig();
    },
    dragndropFile: function( e ) {
      this.$refs.fileupload.setFiles( e.dataTransfer.files );
    },
    startUpload: function () {
      let fileList = this.$refs.fileupload.getFiles();
      let newFiles = [];
      for (let i = 0; i < fileList.length; i++) {
        let file = fileList[i];

        let newFile = {
          name:file.name,
          status:FILESTATUS.LOADING,
          identifier:"",
          iconURL:"",
          file: file
        }

        if ( file.size > MAX_FILESIZE )
        {
          newFile.status = FILESTATUS.ERROR_FILESIZE;
        }

        newFiles.push(newFile);
      }
      this.internalFiles.push(...newFiles)

      if( newFiles.every(newFile => newFile.status === FILESTATUS.LOADING) )
      {
        this.$refs.fileupload.startUpload();
      }
    },
    uploadStarts: function () {
      // upload could take a second, setting overall status to prevent user from proceeding to basket.
      // this will be overwritten by the config validation after the upload is done
      this.configuratorService.observableData.data.overallStatus.message = translatePrj('uploadfileUploadInProgress');
      this.configuratorService.observableData.data.overallStatus.status = OVERALLSTATUS.INCOMPLETE;
    },
    uploadFinished: function (data) {
      // alter basket-view.js: function multiplexFiles(data, existingFiles) ... as well!!!
      var filenames = data.filenames.split("\n");
      var identifier = data.identifier.split("\n");

      for (var i = 0; i < filenames.length; i++) {
        let file = this.internalFiles.find(file => uEqual(file.name, filenames[i]) && file.status !== FILESTATUS.OK);
        if(file){
          file.identifier = identifier[i]
        }
      }

      this.validateConfig();
    },
    updateUploadState: function( data ) {
      console.log("updateUploadState:")
      console.log(data);
    },
    uploadError: function( response ) {
      console.log("error");
      console.log(response);

      if (response.status == 413) {
        this.internalFiles.forEach(file=> file.status !== FILESTATUS.OK ? file.status = FILESTATUS.ERROR_FILESIZE : file.status = FILESTATUS.OK)
      } else {
        this.internalFiles.forEach(file=> file.status !== FILESTATUS.OK ? file.status = FILESTATUS.ERROR_FILETYPE : file.status = FILESTATUS.OK)
      }
    },
    validateConfig: function() {
      this.option.dynamicValues.files = this.internalFiles.map(
          file =>
              ({
                name: file.name,
                status: file.status,
                identifier: file.identifier
              })
      );
      this.configuratorService.validate();
    }
  },
  computed: {
    notSafari() {
      return !isSafari();
    },
    showUpload() {
      return this.configuratorService.getSelectedAuspraegung( this.option ).id === this.option.customValues.withUpload
    },
    files() {
      return this.option.dynamicValues.files;
    }
  },
  mounted() {
    this.helper = new ProduktRESTHelper(window.FlyerlineConfig.product_key);
    this.loadFilesForBasketItem();

  },
  watch:{
    files(newVal){
      this.internalFiles.forEach(
          function( file ) {
            const matchingFile = newVal.find( newFile => newFile.name === file.name );
            file.status = matchingFile?.status;
          }
      )
    }
  }
}
</script>
